// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

// Utils
import { getBadgeImagePlaceholderUrl, getBadgeImageUrl, localizeBadgeTitleReact } from 'utils/BadgeUtils';

class BadgeImage extends React.Component {
    constructor() {
        super();

        this.state = {
            imageError: false
        };
    }

    render() {
        const { badge, size } = this.props;
        let placeholderStyle;
        if (!size || size === 'lrg') {
            let small = getBadgeImageUrl(badge.badgeId, 'sml', badge.badgeUuid);
            placeholderStyle = {
                backgroundImage: `url(${small})`,
                backgroundPosition: 'center',
                backgroundSize: '100%',
                backgroundRepeat: 'no-repeat'
            };
        }

        return (
            <img
                src={
                    this.state.imageError
                        ? getBadgeImagePlaceholderUrl()
                        : getBadgeImageUrl(badge.badgeId, size, badge.badgeUuid)
                }
                alt={localizeBadgeTitleReact(badge.badgeKey, i18next)}
                className="badge-img"
                onError={() => this.handleImageError()}
                style={placeholderStyle}
            />
        );
    }

    handleImageError() {
        this.setState({
            imageError: true
        });
    }
}

BadgeImage.propTypes = {
    badge: PropTypes.object.isRequired,
    size: PropTypes.oneOf(['sml', 'lrg'])
};

export default withTranslation(['badges-list'])(BadgeImage);
